// import '@babel/polyfill';

export const onClientEntry = () => {
  console.log('%cStart Gatsby Advanced Blog!', 'display: block; color: #9f63f0; font-size: 40px;');
};
